import { getErrorMessage } from '@/lib/api'

// Assignment target type for users and teams
export interface AssignmentTarget {
  id: number
  name: string
  type: 'user' | 'team'
}

export interface MentionPayload {
  mentioned_user_ids: number[]
  mentioned_team_ids: number[]
}

export const getMentionText = (target: AssignmentTarget) => `@${target.name}`

export const getTargetKey = (target: AssignmentTarget) => `${target.type}-${target.id}`

export const pruneMentionTargets = (
  content: string,
  targets: AssignmentTarget[]
): AssignmentTarget[] => targets.filter((target) => content.includes(getMentionText(target)))

export const addMentionTarget = (
  targets: AssignmentTarget[],
  targetToAdd: AssignmentTarget
): AssignmentTarget[] => {
  const targetKey = getTargetKey(targetToAdd)
  if (targets.some((target) => getTargetKey(target) === targetKey)) {
    return targets
  }

  return [...targets, targetToAdd]
}

export const getMentionPayload = (content: string, targets: AssignmentTarget[]): MentionPayload => {
  const activeTargets = pruneMentionTargets(content, targets)

  return {
    mentioned_user_ids: activeTargets
      .filter((target) => target.type === 'user')
      .map((target) => target.id),
    mentioned_team_ids: activeTargets
      .filter((target) => target.type === 'team')
      .map((target) => target.id),
  }
}

export const getToastErrorMessage = (error: unknown, fallback: string): string => {
  const message = getErrorMessage(error)
  return message === 'An unexpected error occurred' ? fallback : message
}
